import { AbstractControl, ValidationErrors } from '@angular/forms';
import { from, Observable, timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { LocationEnvironmentApi } from '../../../../core/api/location-environment/location-environment.api';


export const locationEnvironmentNameUniqueAsyncValidator = ({ locationEnvironmentApi, locationSectorId, locationEnvironmentId }: {
  locationEnvironmentApi: LocationEnvironmentApi,
  locationSectorId: string,
  locationEnvironmentId: string
}) => {
  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    const name = control.value;

    if (!locationSectorId) {
      return timer(0)
        .pipe(
          map(() => null)
        );
    }

    return timer(500)
      .pipe(
        switchMap(() => locationEnvironmentApi.search({
          where: {
            nameEq: name,
            locationSectorId: locationSectorId,
          },
          limit: 1,
          offset: 0,
        })),
        map(({ items }) => {
          return items.some((item) => item.id !== locationEnvironmentId)
            ? { nameAlreadyExists: true }
            : null;
        })
      );
  };
};
